/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AuthUpdateProfileResponse } from "./AuthUpdateProfileResponse";

export type AuthUpdateProfileResponseApiRespoonse = {
  data?: AuthUpdateProfileResponse;
  status?: AuthUpdateProfileResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace AuthUpdateProfileResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
